import React, { useState, useEffect, useCallback} from 'react'
import { Add, DeleteForever, LinkTwoTone, Videocam, PictureAsPdf, VolumeUp } from '@material-ui/icons';
import { confirmAlert } from 'react-confirm-alert';
import ImageViewer from 'react-simple-image-viewer';

import incident_manager from '../api/incident'
import { hasPrivileges } from '../util/auth';
import AddIncidentMediaPopup from './add_incident_media_popup';
import { buildMediaObject } from '../util/media';

export default function IncidentMedia(props){
    let incidentId = props.incidentId
    let [images, setImages] = useState([])
    let [imageIds, setImageIds] = useState([])
    let [links, setLinks] = useState([])
    let [linkIds, setLinkIds] = useState([])
	let [videoLinks, setVideoLinks] = useState([])
    let [videoLinkIds, setVideoLinkIds] = useState([])
	let [pdfLinks, setPdfLinks] = useState([])
    let [pdfLinkIds, setPdfLinkIds] = useState([])
	let [audioLinks, setAudioLinks] = useState([])
    let [audioLinkIds, setAudioLinkIds] = useState([])
    let [imageOpened, setImageOpened] = useState(false)
    let [openedImage, setOpenedImage] = useState(0)

    let [popupVisible, setPopupVisible] = useState(false)
    let [selectedType, setSelectedType] = useState("IMAGE")
    let [incidentMediaUrl, setIncidentMediaUrl] = useState(null)

    useEffect(()=>{
        loadMedia();
    }, [incidentId])

    let loadMedia = async () => {
        const mediaList = await incident_manager.incident_media(incidentId);

        if (mediaList) {
            const mediaObject = buildMediaObject(mediaList, true)
            const { image, video, audio, pdf, link } = mediaObject;

            setImages(image['urls'])
            setImageIds(image['ids'])
            setVideoLinks(video['urls'])
            setVideoLinkIds(video['ids'])
            setPdfLinks(pdf['urls'])
            setPdfLinkIds(pdf['ids'])
            setAudioLinks(audio['urls'])
            setAudioLinkIds(audio['ids'])
            setLinks(link['urls'])
            setLinkIds(link['ids'])
        } else {
            setImages([])
            setImageIds([])
            setLinks([])
            setLinkIds([])
            setVideoLinks([])
            setVideoLinkIds([])
            setPdfLinks([])
            setPdfLinkIds([])
            setAudioLinks([])
            setAudioLinkIds([])
        }
    }

    const openImageViewer = useCallback((index) => {
        setOpenedImage(index);
        setImageOpened(true);
    }, []);
    
    const closeImageViewer = () => {
        setOpenedImage(0);
        setImageOpened(false);
    };

    const addMedia = () =>{
        console.log(selectedType)
        incident_manager.add_incident_media(incidentId, selectedType, incidentMediaUrl).then(id=>{
            console.log("Added media ",id);
            setIncidentMediaUrl(null);
            setPopupVisible(false);
            loadMedia();
        })
    }

    const deleteMedia = (id) =>{
        console.log("Removing media id ",id)
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure you want to delete the media '+id+"?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    incident_manager.remove_incident_media(id).then(resp=>{
                        if(resp!==null){
                            setImageIds([])
                            setImages([])
							setVideoLinks([])
							setVideoLinkIds([])
							setPdfLinks([])
							setPdfLinkIds([])
							setAudioLinks([])
							setAudioLinkIds([])
                            setLinks([])
                            setLinkIds([])
                            loadMedia();
                        }
                    })
                }
              },
              {
                label: 'No',
                onClick: () =>{
                }
              }
            ]
          });
    }

    const hidePopup = () => {
        setPopupVisible(false)
    }

    const handleClick = async (e, src) => {
        // Media URLs from api.sportsdatascience.be need to be authenticated
        e.preventDefault();
        if (src.includes("api.sportsdatascience.be")) {
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(src, {
                    headers: {
                    'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch the video');
                }

                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                setTimeout(() => window.URL.revokeObjectURL(blobUrl), 10000);
            } catch (error) {
                console.error('Error fetching video:', error);
            }
        } else {
            window.open(src, '_blank');
        }
    }

    return (
        <div className='incidentMediaContainer' style={{maginBottom: 30}}>
            <h3>Incident media</h3>
            {hasPrivileges("commissaire")?
            <div className='newIncidentMediaContainer'>
                <span className='btn btn-success' onClick={()=>setPopupVisible(true)}><Add/> Add media</span>
                <AddIncidentMediaPopup      selectedType={selectedType} 
                                            changeSelectedType={(evt)=>{console.log(evt);setSelectedType(evt.target.value)}}
                                            selectedIncidentMediaUrl={incidentMediaUrl}
                                            changeSelectedIncidentMediaUrl={(evt)=>{setIncidentMediaUrl(evt.target.value)}}
                                            setUploadedUrl={(val)=>setIncidentMediaUrl(val)}
                                            addMedia={addMedia}
                                            hidePopup={hidePopup}
                                            visible={popupVisible}
                />
            </div>:
            ""}
            <h5>Images</h5>                
            <div className='imgThumbContainer'>
                {images.map((src, index) => (
                    <div className='imgThumb' key={`img-${src}`} style={{cursor: "pointer"}}>
                        <img
                        src={ src }
                        onClick={ () => openImageViewer(index) }
                        width="300"
                        key={ index }
                        style={{ margin: '2px' }}
                        alt=""/>
                        {hasPrivileges('commissaire')?<div className='imageDeleteBtn' onClick={()=>deleteMedia(imageIds[index])}><span className='btn btn-danger'><DeleteForever/></span></div>:""}
                    </div> 
                ))}
            </div>
            {imageOpened && (
                <ImageViewer
                src={ images }
                currentIndex={ openedImage }
                onClose={ closeImageViewer }
            />)}
            <h5>Links</h5>
            <ul className='incidentMediaLinkContainer'>
                {videoLinks.map((src, index)=>{
                    return <li className='incidentMediaLink' key={`video-link-${index}`}>
                                <a href={src} style={{color: "black"}} target='blank' /*onClick={(e) => handleClick(e, src)}*/ rel='noopener noreferrer'><Videocam alt={index+1}/></a>
                                {hasPrivileges("commissaire")?<div className='linkDeleteBtn' onClick={()=>deleteMedia(videoLinkIds[index])}>
                                    <span className='btn btn-danger'>
                                        <DeleteForever/>
                                    </span>
                                </div>:""}
                    </li>
                })}				
				{audioLinks.map((src, index)=>{
                    return <li className='incidentMediaLink' key={`audio-link-${index}`}>
                                <a href={src} style={{color: "black"}} target='blank' rel='noopener noreferrer'><VolumeUp alt={index+1}/></a>
                                {hasPrivileges("commissaire")?<div className='linkDeleteBtn' onClick={()=>deleteMedia(audioLinkIds[index])}>
                                    <span className='btn btn-danger'>
                                        <DeleteForever/>
                                    </span>
                                </div>:""}
                    </li>
                })}
				{pdfLinks.map((src, index)=>{
                    return <li className='incidentMediaLink' key={`pdf-link-${index}`}>
                                <a href={src} style={{color: "black"}} target='blank' rel='noopener noreferrer'><PictureAsPdf alt={index+1}/></a>
                                {hasPrivileges("commissaire")?<div className='linkDeleteBtn' onClick={()=>deleteMedia(pdfLinkIds[index])}>
                                    <span className='btn btn-danger'>
                                        <DeleteForever/>
                                    </span>
                                </div>:""}
                    </li>
                })}	
				{links.map((src, index)=>{
                    return <li className='incidentMediaLink' key={`general-link-${index}`}>
                                <a href={src} target='blank' rel='noopener noreferrer'><LinkTwoTone alt={index+1}/></a>
                                {hasPrivileges("commissaire")?<div className='linkDeleteBtn' onClick={()=>deleteMedia(linkIds[index])}>
                                    <span className='btn btn-danger'>
                                        <DeleteForever/>
                                    </span>
                                </div>:""}
                    </li>
                })}
            </ul>
        </div>
    )
}
